<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Proveedores ERP </span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>BO_04</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos text-left">
          Búsqueda de proveedores
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left" v-if="$localStorageService.can('Busqueda_proveedor')">
                <label for="nombreBusq">Buscar</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre de proveedor"
                                min="3"
                                v-model="filtro.nombre" @keydown.enter.native="obtenerProveedores"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right" v-if="$localStorageService.can('Nuevo_proveedor')">
                <b-button v-b-tooltip.hover title="Crear proveedor" variant="outline-success"
                          @click="agregar()">Crear proveedor
                </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button v-if="$localStorageService.can('Editar_proveedor')"
                          title="Modificar Usurio"
                          size="sm"
                          @click="modificar(row.item)"
                          variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo && $localStorageService.can('Activar_proveedor') "
                          title="Activar usuario"
                          variant="outline-danger"
                          size="sm"
                          @click="cambiarEstatus(row.item, true)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else-if="$localStorageService.can('Activar_proveedor')"
                          title="Eliminar usuario"
                          variant="outline-danger"
                          size="sm"
                          @click="cambiarEstatus(row.item, false)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>

            <template v-slot:cell(fechaModificacion)="row">
              {{ row.item.fechaModificacion |formatoFechaCorta }}
            </template>

          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>


    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
    >
      <b-container fluid>
        <b-form>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="nombreProveedor">Nombre
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-input id="idNombreProveedor" name="nombreProveedor" placeholder="Proveedor"
                                v-model="$v.proveedor.descripcion.$model"
                                :state="validateState('descripcion')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label for="claveProveedor">Clave
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-input id="idClaveProveedor" name="claveProveedor" placeholder="Clave"
                                v-model="$v.proveedor.clave.$model"
                                type="number"
                                :state="validateState('clave')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click.prevent="guardar"
                  v-if="$localStorageService.can('Nuevo_proveedor') || $localStorageService.can('Editar_proveedor ')">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

export default {
  name: "proveedoresERP",
  components: {
    Header
  },
  mixins: [validationMixin],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "idProveedorERP", label: "ID", sortable: true},
        {key: "clave", label: "Clave", sortable: true},
        {key: "descripcion", label: "Nombre de usuario", sortable: true},
        {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
        {key: "usuarioModificacion", label: "Nombre usuario que modificó", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      show: false,
      tituloModal: '',
      proveedor: {
        idProveedorERP: null,
        descripcion: null,
        clave: null,
      },
      loaderAcciones: false,
      loader: false,
      mostrarBoton: false,
      filtro: {
        nombre: null,
      },
    }
  },
  validations: {
    proveedor: {
      descripcion: {required},
      clave: {required},
    }
  },
  mounted() {
    this.obtenerProveedores();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerProveedores() {
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + 'proveedoreERP/buscarProveedoresERP', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
              // this.datosTabla.forEach(element => {
              //   element.fechaModificacion = this.$moment(element.fechaModificacion).format('DD-MM-YYYY');
              // });
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },

    agregar() {
      this.proveedor = {
        idProveedorERP: null,
        descripcion: null,
        clave: null,
      };
      this.tituloModal = 'Agregar Proveedor';
      this.show = true;
    },
    modificar(item) {
      this.proveedor = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar Proveedor';
      this.mostrarBoton = true;
      this.show = true;
    },

    guardar() {

      this.$v.proveedor.$touch();
      if (this.$v.proveedor.$anyError) {
        return;
      }
      this.loaderAcciones = true;

      const envio = JSON.parse(JSON.stringify(this.proveedor));

      this.$http.post(this.$api + 'proveedoreERP/guardarProveedoresERP', envio).then(respuesta => {
            if (respuesta.data.data) {
              this.obtenerProveedores();
              this.show = false;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: respuesta.data.message,
              });
            }
          }
      ).catch((error) => {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: error.response.data.message,
        });
      }).finally(() =>
          this.loaderAcciones = false
      )

      // }
    },


    cambiarEstatus(item, estatus) {
      const mensaje = estatus ? '¿Está seguro de activar el proveedor?' : '¿Está seguro de desactivar el proveedor?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.loaderAcciones = true;
          this.$http.post(this.$api + 'proveedoreERP/cambiarEstatusProveedoresERP',
              {
                  idProveedorERP: item.idProveedorERP,
                  activo: estatus
              })
              .then(respuesta => {
                item.registroActivo = !item.registroActivo;
                this.loaderAcciones = false;
                this.$swal.fire({
                  icon: "success",
                  title: "Aviso",
                  confirmButtonText: 'De acuerdo',
                  text: respuesta.data.message,
                });
              }).catch((err) => {
                this.loaderAcciones = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  confirmButtonText: 'De acuerdo',
                  text: err.response.data.message,
                });
              });
        }
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.proveedor[name];
      return $dirty ? !$error : null;
    },
    cerrarModal() {
      this.show = false;
    },
    cancelarCambio() {
      this.mostrarBoton = true;
    }
  }
}
</script>

<style scoped>

</style>
